(function () {
  function initD1ServiceScroll() {
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-d1-service-panel]'));

    if (panels.length < 2) {
      var oldNav = document.querySelector('.d1-service-scroll-nav');
      if (oldNav) oldNav.remove();
      return;
    }

    var nav = document.querySelector('.d1-service-scroll-nav');

    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'd1-service-scroll-nav';
      nav.setAttribute('aria-label', 'Service section navigation');
      document.body.appendChild(nav);
    }

    nav.innerHTML = '';

    panels.forEach(function (panel, index) {
      if (!panel.id) panel.id = 'D1ServicePanelAuto-' + index;

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'd1-service-scroll-nav__dot';
      dot.setAttribute('aria-label', 'Go to service section ' + (index + 1));
      dot.addEventListener('click', function () {
        panel.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      nav.appendChild(dot);
    });

    var dots = Array.prototype.slice.call(nav.querySelectorAll('.d1-service-scroll-nav__dot'));

    function getActivePanel() {
      var viewportPoint = window.innerHeight * 0.5;
      var activePanel = panels[0];

      panels.forEach(function (panel) {
        var rect = panel.getBoundingClientRect();

        if (rect.top <= viewportPoint && rect.bottom >= viewportPoint) {
          activePanel = panel;
        }
      });

      return activePanel;
    }

    function setActive(activePanel) {
      var activeIndex = panels.indexOf(activePanel);
      var dotColor = activePanel.getAttribute('data-d1-dot-color');

      if (dotColor === 'light') {
        nav.classList.add('is-light');
      } else {
        nav.classList.remove('is-light');
      }

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    function updateActive() {
      setActive(getActivePanel());
    }

    window.removeEventListener('scroll', window.d1ServiceScrollUpdate);
    window.removeEventListener('resize', window.d1ServiceScrollUpdate);

    window.d1ServiceScrollUpdate = updateActive;

    window.addEventListener('scroll', window.d1ServiceScrollUpdate, { passive: true });
    window.addEventListener('resize', window.d1ServiceScrollUpdate);

    updateActive();
  }

  document.addEventListener('DOMContentLoaded', initD1ServiceScroll);
  document.addEventListener('shopify:section:load', initD1ServiceScroll);
  document.addEventListener('shopify:section:unload', initD1ServiceScroll);
})();